import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { combineLatest, map, Subscription } from 'rxjs';
import { AuthenticationService } from 'src/app/core/service/authentication.service';
import { MockServerService } from 'src/app/shared/mock-server.service';

@Component({
  selector: 'app-forgot-pwd',
  templateUrl: './forgot-pwd.component.html',
  styleUrls: ['./forgot-pwd.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ForgotPwdComponent implements OnInit {

  // email = new FormControl('', [Validators.required, Validators.email]);
  initiateResetPwd: boolean = false;
  fieldTextType: boolean = false;
  successMessage!: string;
  isNetworkError: boolean = false;
  errorMessage!: string;
  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }

  resetPwdFormGroup!: FormGroup; // Initialize the form property
  private subscriptions: Subscription[] = [];
  constructor(
    private formBuilder: FormBuilder, private authService: AuthenticationService,
    private router: Router,
    public activatedRoute: ActivatedRoute,
    private mockServerService: MockServerService
  ) { }



  ngOnInit() {
    this.resetPwdFormGroup = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]]
      // Your form controls and validators here
    });

      // Subscribe to mock server status changes
      this.mockServerService.mockServerStatus$.subscribe((status) => {
        this.mockServerActive = status;
      });

    // Subscribe to query parameters to check for enable_mock_mode
    // this.activatedRoute.queryParams.subscribe(params => {
    //   const hasMockModeParam = params['enable_mock_mode'] === 'true';
    //   const environmentAllowsMock = this.authService.isMockModeAllowed();
    //   this.showAdminWidget = hasMockModeParam && environmentAllowsMock;
    // });
    const mockParam$ = this.activatedRoute.queryParams.pipe(
      map(params => params['enable_mock_mode'] === 'true')
    );
  
    const mockServer$ = this.mockServerService.showAdminWidget$;
  
    this.subscriptions.push(combineLatest([mockParam$, mockServer$]).subscribe(
      ([hasMockModeParam, show]) => {
        const environmentAllowsMock = this.authService.isMockModeAllowed();
        this.showAdminWidget = show || (hasMockModeParam && environmentAllowsMock);
      }
    ));
  }
  getEmailErrorMessage() {
    // console.log("I am here");
    if (this.resetPwdFormGroup.get('email')?.hasError('required')) {
      return 'This is a required field.';
    }

    return this.resetPwdFormGroup.get('email')?.hasError('email') ? 'Please enter your email address.' : '';
  }

  resetPwdProcessInitiate() {
    this.successMessage = '';
    this.errorMessage = '';
    this.isNetworkError = false;
    const emailValue = this.resetPwdFormGroup.get('email')?.value?.toLowerCase()?.trim() || '';
    this.initiateResetPwd = true;
    this.authService.forgotPwd({ email: emailValue }).subscribe({
      next: (response: any) => {
        console.log('response:', response);
        if (response.success) {
          this.successMessage = 'Password reset sent via email.';
          this.resetPwdFormGroup.get('email')?.reset('', { emitEvent: false });

          // this.router.navigate(['/login']);
        }
      }, error: (error: any) => {
        console.log('error:', error);
        this.initiateResetPwd = false;
        this.isNetworkError = error.status?.toString() === '0' || error.status?.toString() === '429';
        if (error.status === 400) {
          this.errorMessage = error.error?.message || 'Provided email address is not valid.';
        } else {
          this.errorMessage = 'Something went wrong. Please try again later.';
        }
      },
      complete: () => {
        this.initiateResetPwd = false;
      }
    }
    );
  }

  
  //Admin Widget
  isToggleAdminFlagOpen: boolean = false;
  toggleAdminFlag: boolean = false;
  toggleAdminWidget() {
    this.toggleAdminFlag = !this.toggleAdminFlag;
  }

  // Admin Widget visibility based on query parameter
  showAdminWidget: boolean = false;

  mockServerActive = this.mockServerService.getMockServerStatus();

}
